// src/utils/firebase/functionsWithRoutes.js
//
// The web build resolves `firebase/functions` HERE (vue.config.js alias, exact match): everything the SDK exports,
// with httpsCallable made route-aware (callRouteCore.js; Phase 98 §7.3). So every call site in the app, dynamic imports
// included, goes to the router that serves its name with no change of its own; a name no router serves is the SDK's
// httpsCallable. This file imports the SDK's implementation package, @firebase/functions (what firebase/functions
// re-exports), so the alias never points at itself.

import * as sdk from '@firebase/functions'
import routeMap from '@/generated/functionRoutes.json'
import { makeRouteCallable, routerIndex } from './callRouteCore'

export * from '@firebase/functions'

export const httpsCallable = makeRouteCallable({ sdk, routers: routerIndex(routeMap) })
